import React from "react";
import Navbar from "../components/Navbar";
import HeroImage2 from "../components/HeroImage2";
import Footer from "../components/Footer";
import PricingCart from "../components/PricingCart";
import Work from './../components/Work';
import Featured from "../components/Featured";

const Project = () => {
  return (
    <div>
      <Navbar />
      <HeroImage2 heading="PROJECTS" text="Some of my recent work" />
      <Work />
      <Featured/>
      <PricingCart />
      <Footer />
    </div>
  );
};

export default Project;
